/** Dashboard widget: background scheduler running status. */

import React, { useEffect, useState } from "react";
import { apiClient } from "@/api/client";
import type { SystemHealth } from "@/types";
import WidgetCard from "./WidgetCard";

export default function SchedulerStatusWidget(): React.ReactElement {
  const [health, setHealth] = useState<SystemHealth | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .get<SystemHealth>("/system/health")
      .then(({ data }) => setHealth(data))
      .catch(() => setError("Unable to load scheduler status"));
  }, []);

  return (
    <WidgetCard title="Scheduler status" isLoading={health === null && !error} error={error}>
      {health && (
        <div className="flex items-center gap-2">
          <span
            className={`h-2.5 w-2.5 rounded-full ${health.scheduler_running ? "bg-signal-teal" : "bg-signal-rose"}`}
          />
          <p className="text-sm text-mist-200">{health.scheduler_running ? "Running" : "Stopped"}</p>
        </div>
      )}
    </WidgetCard>
  );
}
